import {
  PlacementWarningDialog,
  type PlacementWarningDialogProps,
} from '@/components/app/placement/placement-warning-dialog'

/** Mirrors `PhotoSizeWarningAlert` — Cancel/Continue only, every implicit Radix dismiss blocked. */
export function ClikArtSizeWarningAlert(props: PlacementWarningDialogProps) {
  return (
    <PlacementWarningDialog
      {...props}
      tone="warning"
      title="ClikArt Size"
      message="This ClikArt is too small. Continuing will place it in a new frame."
      continueLabel="Continue"
    />
  )
}
